module.exports = __webpack_public_path__ + "img/icon_map_62_off_110.eda71f3f.png";